// しんかのきせき対象（最終進化前）ポケモンID
export const NOT_LAST_EVOLVE_POKEMON_IDS = new Set<number>([
  1,
  2,
  4,
  5,
  7,
  8,
  10,
  11,
  13,
  14,
  16,
  17,
  19,
  21,
  23,
  25,
  27,
  29,
  30,
  32,
  33,
  35,
  37,
  39,
  41,
  42,
  43,
  44,
  46,
  48,
  50,
  52,
  54,
  56,
  57,
  58,
  60,
  61,
  63,
  64,
  66,
  67,
  69,
  70,
  72,
  74,
  75,
  77,
  79,
  81,
  82,
  84,
  86,
  88,
  90,
  92,
  93,
  95,
  96,
  98,
  100,
  102,
  104,
  108,
  109,
  111,
  112,
  113,
  114,
  116,
  117,
  118,
  120,
  123,
  125,
  126,
  129,
  133,
  137,
  138,
  140,
  147,
  148,
  152,
  153,
  155,
  156,
  158,
  159,
  161,
  163,
  165,
  167,
  170,
  172,
  173,
  174,
  175,
  176,
  177,
  179,
  180,
  183,
  187,
  188,
  190,
  191,
  193,
  194,
  198,
  200,
  203,
  204,
  206,
  207,
  209,
  215,
  216,
  217,
  218,
  220,
  221,
  223,
  228,
  231,
  233,
  234,
  236,
  238,
  239,
  240,
  246,
  247,
  252,
  253,
  255,
  256,
  258,
  259,
  261,
  263,
  264,
  265,
  266,
  268,
  270,
  271,
  273,
  274,
  276,
  278,
  280,
  281,
  283,
  285,
  287,
  288,
  290,
  293,
  294,
  296,
  298,
  299,
  300,
  304,
  305,
  307,
  309,
  315,
  316,
  318,
  320,
  322,
  325,
  328,
  329,
  331,
  333,
  339,
  341,
  343,
  345,
  347,
  349,
  353,
  355,
  356,
  360,
  361,
  363,
  364,
  366,
  371,
  372,
  374,
  375,
  387,
  388,
  390,
  391,
  393,
  394,
  396,
  397,
  399,
  401,
  403,
  404,
  406,
  408,
  410,
  412,
  415,
  418,
  420,
  422,
  425,
  427,
  431,
  433,
  434,
  436,
  438,
  439,
  440,
  443,
  444,
  446,
  447,
  449,
  451,
  453,
  456,
  458,
  459,
  489,
  495,
  496,
  498,
  499,
  501,
  502,
  504,
  506,
  507,
  509,
  511,
  513,
  515,
  517,
  519,
  520,
  522,
  524,
  525,
  527,
  529,
  532,
  533,
  535,
  536,
  540,
  541,
  543,
  544,
  546,
  548,
  550,
  551,
  552,
  554,
  557,
  559,
  562,
  564,
  566,
  568,
  570,
  572,
  574,
  575,
  577,
  578,
  580,
  582,
  583,
  585,
  588,
  590,
  592,
  595,
  597,
  599,
  600,
  602,
  603,
  605,
  607,
  608,
  610,
  611,
  613,
  616,
  619,
  622,
  624,
  625,
  627,
  629,
  633,
  634,
  636,
  650,
  651,
  653,
  654,
  656,
  657,
  659,
  661,
  662,
  664,
  665,
  667,
  669,
  670,
  672,
  674,
  677,
  679,
  680,
  682,
  684,
  686,
  688,
  690,
  692,
  694,
  696,
  698,
  704,
  705,
  708,
  710,
  712,
  714,
  722,
  723,
  725,
  726,
  728,
  729,
  731,
  732,
  734,
  736,
  737,
  739,
  742,
  744,
  747,
  749,
  751,
  753,
  755,
  757,
  759,
  761,
  762,
  767,
  769,
  772,
  782,
  783,
  789,
  790,
  803,
  810,
  811,
  813,
  814,
  816,
  817,
  819,
  821,
  822,
  824,
  825,
  827,
  829,
  831,
  833,
  835,
  837,
  838,
  840,
  843,
  846,
  848,
  850,
  852,
  854,
  856,
  857,
  859,
  860,
  868,
  872,
  878,
  884,
  885,
  886,
  891,
  906,
  907,
  909,
  910,
  912,
  913,
  915,
  917,
  919,
  921,
  922,
  924,
  926,
  928,
  929,
  932,
  933,
  935,
  938,
  940,
  942,
  944,
  946,
  948,
  951,
  953,
  955,
  957,
  958,
  960,
  963,
  965,
  969,
  971,
  974,
  996,
  997,
  999,
  1011,
  1012,
  10166,
  10168,
  10173,
  10234,
]);
